import React, { Component } from 'react';
import './_styles.scss';

export default class ButtonPrimary extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, type, onClick } = this.props;

    const typeClassMap = {
      LOGIN: 'landing-telmex__button-primary--login',
      REGISTER: 'landing-telmex__button-primary--register',
      DEFAULT: 'landing-telmex__button-primary--default',
    };

    const typeClass = typeClassMap[type] || typeClassMap.DEFAULT;

    return (
      <button
        className={`landing-telmex__button-primary ${typeClass} focusable`}
        onClick={() => onClick && onClick()}
      >
        {title}
      </button>
    );
  }
}


// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/ButtonPrimary/index.jsx